<style>
.ag-theme-material .ag-cell {
    line-height: 35px !important;
}
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card class="p-4 mb-6">
            <div class="flex flex-wrap items-center justify-between mb-10">
                <div class="flex items-center">
                    <h4 style="margin-left: 10px">Delivery Order</h4>
                </div>
                <div class="flex items-center">
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                        >Refresh</vs-button
                    >
                    <!-- <vs-button @click="searchDoInit" class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button> -->
                    <vs-button
                        :to="{
                            name: 'delivery-order-view',
                            params: { id: selectedId },
                        }"
                        class="mb-4 md:mb-0 mr-1"
                        icon="remove_red_eye"
                        :disabled="selectedId ? false : true"
                        >View</vs-button
                    >
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="removeItem"
                        icon="delete"
                        :disabled="selectedId ? false : true"
                        >Delete</vs-button
                    >
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="filter_list"
                        @click="filterInit"
                        >Filter</vs-button
                    >
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="import_export"
                        @click="
                            exportExcel({
                                endpoint:
                                    'outbound/deliveryorder/report/download_excel',
                                filter: filter,
                                name: 'delivery_order',
                            })
                        "
                        >Export</vs-button
                    >
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="import_export"
                        @click="
                            exportExcel({
                                endpoint:
                                    'outbound/deliveryorder/report/download_packing',
                                filter: filter,
                                name: 'packing',
                            })
                        "
                        >Export Packing</vs-button
                    >
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="print"
                        @click="
                            exportExcel({
                                endpoint:
                                    'outbound/deliveryorder/report/download_invoice',
                                filter: filter,
                                name: 'invoice',
                            })
                        "
                        >Invoice</vs-button
                    >
                    <!-- <vs-button class="mb-4 md:mb-0 mr-1" icon="filter_list">Filter</vs-button> -->
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="deliveryOrders"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="viewData"
            >
            </ag-grid-vue>
            <p class="text-right">
                <b
                    >Showing {{ dataFrom }} to {{ dataTo }} of
                    {{ dataTotal }} total entries</b
                >
            </p>
            <vs-pagination
                :total="totalPage"
                v-model="currentPage"
            ></vs-pagination>
            <vs-prompt
                @accept="searchDO"
                :active.sync="activeSearchDO"
                title="Search Outbound"
            >
                <div class="con-exemple-prompt">
                    <vs-input
                        placeholder="Outbound Reference *"
                        v-model="data.outbound_reference"
                        class="mt-4 mb-2 w-full"
                    />
                    <vs-select
                        class="selectExample"
                        v-model="data.client_id"
                        width="100%"
                        autocomplete
                        @input-change="searchDropdown($event, client)"
                    >
                        <vs-select-item
                            v-for="(item, index) in client.data"
                            :key="index"
                            :value="item.id"
                            :text="item.client_code"
                        />
                    </vs-select>

                    <vs-alert
                        v-if="doSearchError"
                        color="danger"
                        vs-icon="new_releases"
                        class="mt-5"
                    >
                        {{ doSearchError }}
                    </vs-alert>
                </div>
            </vs-prompt>
        </vx-card>

        <vs-prompt @accept="fetchData" title="Filter" :active.sync="showFilter">
            <div class="con-exemple-prompt">
                <label class="vs-input--label"
                    >Reference (Multi, separated by new line)</label
                >
                <vs-textarea height="50" v-model="filter.reference_multi" />
                <label class="vs-input--label">Client</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_client)"
                >
                    <vs-select-item
                        v-for="(item, index) in ddl_client.data"
                        :key="index"
                        :value="item.id"
                        :text="item.client_code"
                    />
                </vs-select>

                <label class="vs-input--label">Req. Del. Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                        vs-w="5"
                        style="padding-left: 0"
                    >
                        <flat-pickr
                            class="vx-col w-full p-2"
                            v-model="filter.req_del_date_start"
                        />
                    </vs-col>
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                        vs-w="2"
                        >To</vs-col
                    >
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-end"
                        vs-align="center"
                        vs-w="5"
                        style="padding-right: 0"
                    >
                        <flat-pickr
                            class="vx-col w-full p-2"
                            v-model="filter.req_del_date_end"
                        />
                    </vs-col>
                </vs-row>

                <label class="vs-input--label">Posting Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                        vs-w="5"
                        style="padding-left: 0"
                    >
                        <flat-pickr
                            class="vx-col w-full p-2"
                            v-model="filter.posting_date_start"
                        />
                    </vs-col>
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                        vs-w="2"
                        >To</vs-col
                    >
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-end"
                        vs-align="center"
                        vs-w="5"
                        style="padding-right: 0"
                    >
                        <flat-pickr
                            class="vx-col w-full p-2"
                            v-model="filter.posting_date_end"
                        />
                    </vs-col>
                </vs-row>

                <label class="vs-input--label">Good Issue Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                        vs-w="5"
                        style="padding-left: 0"
                    >
                        <flat-pickr
                            class="vx-col w-full p-2"
                            v-model="filter.gi_date_start"
                        />
                    </vs-col>
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                        vs-w="2"
                        >To</vs-col
                    >
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-end"
                        vs-align="center"
                        vs-w="5"
                        style="padding-right: 0"
                    >
                        <flat-pickr
                            class="vx-col w-full p-2"
                            v-model="filter.gi_date_end"
                        />
                    </vs-col>
                </vs-row>

                <vs-input
                    v-model="filter.outbound_reference"
                    class="mb-2 w-full"
                    label="Outbound Reference"
                />
                <vs-input
                    v-model="filter.awb"
                    class="mb-2 w-full"
                    label="Tracking Reference"
                />
                <label class="vs-input--label">Origin ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.origin_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_origin)"
                >
                    <vs-select-item
                        v-for="(item, index) in ddl_origin.data"
                        :key="index"
                        :value="item.id"
                        :text="item.name"
                    />
                </vs-select>

                <label class="vs-input--label">Destination ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.destination_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_destination)"
                >
                    <vs-select-item
                        v-for="(item, index) in ddl_destination.data"
                        :key="index"
                        :value="item.id"
                        :text="item.name"
                    />
                </vs-select>
                <label class="vs-input--label">Order Source</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.order_source_id"
                    width="100%"
                    autocomplete
                >
                    <vs-select-item
                        v-for="(item, index) in order_sources"
                        :key="index"
                        :value="item.id"
                        :text="item.name"
                    />
                </vs-select>
                <label class="vs-input--label">Status</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.status_id"
                    width="100%"
                    autocomplete
                >
                    <vs-select-item
                        v-for="(item, index) in status"
                        :key="index"
                        :value="item.id"
                        :text="item.name"
                    />
                </vs-select>
                <vs-input
                    v-model="filter.movement_id"
                    class="mb-2 w-full"
                    label="Movement ID"
                />
            </div>
        </vs-prompt>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr,
    },
    data() {
        return {
            searchQuery: "",
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            deliveryOrders: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true,
            },
            selectedId: null,
            isLoading: false,
            maxRetry: 10,
            activeSearchDO: false,
            data: {
                outbound_reference: "",
                client_id: null,
            },
            showFilter: false,
            filter: {
                fetchCount: 0,
                do_reference: "",
                client_id: null,
                req_del_date_start: null,
                req_del_date_end: null,
                posting_date_start: null,
                posting_date_end: null,
                gi_date_start: null,
                gi_date_end: null,
                origin_id: null,
                destination_id: null,
                awb: "",
                outbound_reference: "",
                status_id: 1,
                order_source_id: null,
                movement_id: "",
                reference_multi: "",
            },
            ddl_client: {
                data: [],
                loading: false,
                endpoint: "master/clients",
                objectKey: "client_code",
            },
            ddl_origin: {
                data: [],
                loading: false,
                endpoint: "master/customers",
                objectKey: "name",
            },
            ddl_destination: {
                data: [],
                loading: false,
                endpoint: "master/customers",
                objectKey: "name",
            },
            clientOptions: [],
            doSearchError: "",
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            order_sources: [],
            client: {
                data: [],
                loading: false,
                endpoint: "master/clients",
                objectKey: "client_code",
            },
        };
    },
    watch: {
        isLoading: function () {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function () {
            this.fetchData();
        },
    },
    methods: {
        filterInit() {
            if (this.filter.fetchCount < 1) {
                this.isLoading = true;
                this.fetchDropdowns()
                    .then(() => {
                        this.isLoading = false;
                        this.showFilter = true;
                        this.filter.fetchCount++;
                    })
                    .catch(() => {
                        this.isLoading = false;
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: "Server Error",
                            text: "Try again?",
                            accept: () => {
                                this.filterInit();
                            },
                            acceptText: "Yes",
                            cancelText: "No",
                        });
                    });
            } else {
                this.showFilter = true;
            }
        },
        fetchDropdowns() {
            return Promise.all([
                this.$http.post("/master/clients"),
                this.$http.post("/master/customers"),
                this.$http.get("/outbound/outboundstatus"),
                this.$http.get("/master/ordersources"),
            ]).then(
                this.$http.spread(
                    (clients, customers, status, order_sources) => {
                        this.ddl_client.data = clients.data.data;
                        this.ddl_origin.data = customers.data.data;
                        this.ddl_destination.data = customers.data.data;
                        this.order_sources = order_sources.data;
                        this.status = status.data;
                        this.status.unshift({
                            id: null,
                            name: "Any",
                        });

                        this.ddl_origin.data.unshift({
                            id: null,
                            name: "Any",
                        });

                        this.ddl_destination.data.unshift({
                            id: null,
                            name: "Any",
                        });

                        this.ddl_client.data.unshift({
                            id: null,
                            client_code: "Any",
                        });

                        this.order_sources.unshift({
                            id: null,
                            name: "Any",
                        });

                        console.log(this.order_sources);
                    }
                )
            );
        },
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function (selectedRow, index) {
                if (index !== 0) {
                    selectedRowsString += ", ";
                }
                selectedRowsString += selectedRow.id;
            });
            this.selectedId = selectedRowsString;
        },
        removeItem() {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Confirm",
                text: "Are you sure want to delete this do?",
                accept: this.acceptAlert,
            });
        },
        acceptAlert() {
            this.isLoading = true;
            this.$http
                .delete(
                    "outbound/deliveryorder/" + this.selectedId + "/destroy"
                )
                .then(() => {
                    this.$vs.notify({
                        color: "success",
                        title: "Delivery order deleted",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "The selected delivery order was successfully deleted",
                    });
                })
                .catch((error) => {
                    const message = error.response.data.message
                        ? error.response.data.message
                        : "Something went wrong";
                    this.$vs.notify({
                        title: "Error",
                        text: message,
                        color: "danger",
                    });
                })
                .then(() => {
                    this.fetchData();
                });
        },
        refreshData() {
            this.fetchData();
        },
        fetchData() {
            this.isLoading = true;
            this.setFilter(this.filter);
            Promise.all([
                this.$http.post(
                    "outbound/deliveryorder?page=" + this.currentPage,
                    this.filter
                ),
                this.$http.post("unlock_all"),
            ])
                .then(
                    this.$http.spread((resp) => {
                        this.deliveryOrders = resp.data.data;
                        this.totalPage = resp.data.last_page;
                        this.currentPage = this.currentPage;
                        this.dataTotal = resp.data.total;
                        this.dataFrom = resp.data.from;
                        this.dataTo = resp.data.to;
                        this.isLoading = false;
                    })
                )
                .catch(() => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.refreshData();
                        },
                        acceptText: "Yes",
                        cancelText: "No",
                    });
                    return;
                });
        },
        viewData() {
            this.$router.push({
                name: "delivery-order-view",
                params: {
                    id: this.selectedId,
                },
            });
        },
        searchClient(search, loading) {
            loading(true);
            const data = {
                name: search,
            };
            this.$http
                .post("master/clients/filter/search", data)
                .then((res) => {
                    this.clientOptions = res.data;
                    loading(false);
                })
                .catch(() => {
                    this.searchArea(search, loading);
                });
        },
        searchDO() {
            this.doSearchError = "";
            if (!this.data.outbound_reference || !this.data.client_id) {
                this.doSearchError = "Please fill all required fields";
                return false;
            }

            this.isLoading = true;

            this.$http
                .post("outbound/deliveryorder/getdo", {
                    outbound_reference: this.data.outbound_reference,
                    client_id: this.data.client_id,
                })
                .then((res) => {
                    this.$router.push({
                        name: "delivery-order-add",
                        params: {
                            id: res.data.id,
                        },
                    });
                })
                .catch((error) => {
                    const message = error.response.data.message
                        ? error.response.data.message
                        : "Something went wrong";

                    this.isLoading = false;
                    this.activeSearchDO = true;
                    this.doSearchError = message;
                });
        },
        searchDoInit() {
            this.isLoading = true;
            this.maxRetry--;
            this.$http
                .post("master/clients")
                .then((res) => {
                    this.clientOptions = res.data.data;

                    this.isLoading = false;
                    this.activeSearchDO = true;
                })
                .catch(() => {
                    if (this.maxRetry == 0) {
                        this.isLoading = false;
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: "Server Error",
                            text: "Try again?",
                            accept: () => {
                                this.searchDoInit();
                            },
                            acceptText: "Yes",
                            cancelText: "No",
                        });
                        return;
                    }
                    this.searchDoInit();
                });
        },
        fetchDropdown() {
            this.isLoading = true;
            return this.$http.post("master/clients").then((res) => {
                res.data.data.map((client) => {
                    if (
                        this.client.data.findIndex((a) => a.id == client.id) ===
                        -1
                    ) {
                        this.client.data.push(client);
                    }
                });
            });
        },
    },
    mounted() {
        this.fetchDropdown().then(() => this.fetchData());
        this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
        const filter = this.getFilter();

        if (filter) {
            this.filter = filter;
            this.filter.fetchCount = 0;
        }

        this.columnDefs = [
            {
                headerName: "ID",
                field: "id",
                width: 120,
                filter: true,
                // checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                // headerCheckboxSelection: true,
            },
            {
                headerName: "Client ID",
                field: "outbound.client.client_code",
                width: 120,
                filter: true,
                // checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                // headerCheckboxSelection: true,
            },
            {
                headerName: "Reference",
                field: "do_reference",
                filter: true,
                width: 120,
            },
            {
                headerName: "Req. Del. Date",
                field: "outbound.req_del_date",
                filter: true,
                width: 120,
                // pinned: 'left'
            },
            {
                headerName: "Origin",
                field: "outbound.origin.name",
                filter: true,
                width: 120,
            },
            {
                headerName: "Destination",
                field: "outbound.destination.name",
                filter: true,
                width: 120,
            },
            {
                headerName: "Order Source",
                field: "outbound.order_source.name",
                filter: true,
                width: 120,
            },
            {
                headerName: "Outbound Reference",
                field: "outbound.outbound_reference",
                filter: true,
                width: 120,
            },
            {
                headerName: "Status",
                field: "status.name",
                filter: true,
                width: 120,
            },
            {
                headerName: "Created Date",
                field: "created_at",
                filter: true,
                width: 120,
            },
        ];

        this.gridOptions.getRowHeight = function (params) {
            return 35;
        };
    },
};
</script>